import useSWR from "swr";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";

export const useContactLinks = () => {
  const fetcher = useSWRFetcher();

  const { data, isLoading, error } = useSWR<{ addCustomerLink: string; addVendorLink: string }>(
    `${environment.apiUrl}/api/contacts/links`,
    (url: string) => fetcher(url),
    {}
  );

  return {
    links: data,
    isLoading,
    isError: !!error,
  };
};
